export default __webpack_public_path__ + "b7d8b63ca8401053c3f7c892dba471c5.png";